import { inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { tapResponse } from '@ngrx/operators';

import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';
import { pipe, debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs';
import { UtilsService } from 'src/app/modules/shared/services/utils.service';
import { Router } from '@angular/router';
import { EncDecService } from 'src/app/modules/shared/services/encryption-decryption.service';
import { RecipientService } from 'src/app/screens/recipient/services/recipient.service';

interface DoseInfo {
  material_id: number;
  doseName: string;
  doseNo: number;
  isPrecautionDose: boolean;
  vaccination_date: boolean;
  isPastDated: boolean;
}
interface MaterInfo {
  material_id: number | null;
  material_name: string | null;
  isSelected: boolean | null;
  selectedDoses: DoseInfo[] | null;
}
interface SelectedMaterials {
  materials: MaterInfo[] | null;
}
const initialState: SelectedMaterials = {
  materials: [],
};

export const SessionVaccinationStoreData = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(
    (
      store,
      router = inject(Router),
      encDecService = inject(EncDecService),
      utils = inject(UtilsService),
      recipientService = inject(RecipientService)
    ) => ({
      selectMaterial: (material: any) => {
        const currentMaterials = store.materials() ?? [];
        const updatedMaterial: MaterInfo = {
          material_id: material.material_id,
          material_name: material.material_name,
          isSelected: true,
          selectedDoses: [],
        };

        const exists = currentMaterials.some(
          (m) => m.material_id === material.material_id
        );
        const newMaterials = exists
          ? currentMaterials.map((m) =>
              m.material_id === material.material_id ? updatedMaterial : m
            )
          : [...currentMaterials, updatedMaterial];

        patchState(store, {
          materials: newMaterials,
        });
      },

      unSelectMaterial: (material: any) => {
        const currentMaterials = store.materials() ?? [];
        const newMaterials = currentMaterials.filter(
          (m) => m.material_id !== material.material_id
        );

        patchState(store, {
          materials: newMaterials,
        });
      },
      selectDose: (material: any, doseInfo: DoseInfo) => {
        const currentMaterials = store.materials() ?? [];
        const selectedMaterial = currentMaterials.find(
          (m) => m.material_id === material.material_id
        );
        selectedMaterial.selectedDoses = [
          ...selectedMaterial.selectedDoses,
          doseInfo,
        ];
        console.log(material, 'selectedMaterial', selectedMaterial);
        // patchState(store, {
        //   materials: [...currentMaterials, selectedMaterial],
        // });
        // set doseInfo
      },
    })
  )
);
